/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toggle_MenuInputs */

const en_toggle_menu = /** @type {(inputs: Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle menu`)
};

const he_toggle_menu = /** @type {(inputs: Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תפריט`)
};

/**
* | output |
* | --- |
* | "Toggle menu" |
*
* @param {Toggle_MenuInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const toggle_menu = /** @type {((inputs?: Toggle_MenuInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggle_MenuInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toggle_menu(inputs)
	return he_toggle_menu(inputs)
});